import { render } from "./PendingHarvest.vue?vue&type=template&id=0ba2252b&scoped=true"
import script from "./PendingHarvest.vue?vue&type=script&lang=ts"
export * from "./PendingHarvest.vue?vue&type=script&lang=ts"

import "./PendingHarvest.vue?vue&type=style&index=0&id=0ba2252b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0ba2252b"

export default script